import { render, staticRenderFns } from "./c-footer.vue?vue&type=template&id=7701c9d0&scoped=true&"
import script from "./c-footer.vue?vue&type=script&lang=js&"
export * from "./c-footer.vue?vue&type=script&lang=js&"
import style0 from "./c-footer.vue?vue&type=style&index=0&id=7701c9d0&scoped=scoped&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7701c9d0",
  null
  
)

export default component.exports